module.exports = __webpack_public_path__ + "img/pic4.d5f9ca2f.png";